import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import moment from 'moment';

import * as actions from '../../actions/descuentos';
import {api} from '../../actions/_request';

const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);

class DescuentoModal extends React.Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			descuentos: {
                'id'                : null,
                'nombre'            : '',
                'dm_paquete'        : 0,
                'dm_actualizacion'  : 0,
                'dm_caracteristica' : 0,
                'dd_paquete'        : 0,
                'dd_actualizacion'  : 0,
                'dd_caracteristica' : 0,
               
            
            },
            action: 'save',
        };

		this.handleChangeInput 		= this.handleChangeInput.bind(this);
		
		this.handleSubmit 			= this.handleSubmit.bind(this);
   
	}

	componentDidMount()
	{
		

		
       

       

	}

    componentWillReceiveProps(nextProps)
    {
        let {prospectoid} = nextProps;
        let self = this;

        if(prospectoid > 0 && prospectoid != self.state.descuentos.id)
        {
            api().get(`/descuentos/${prospectoid}`)
            .then(function(response)
            {
                if(response.status === 200)
                {
                   
                    self.setState({
                        descuentos: response.data,
                        action: 'update'
                    });             
             }
            });


        }
        else if(prospectoid == null && self.state.descuentos.id)
        {
            self.asNothing();
        }
    }

    asNothing()
    {
        this.setState({
          descuentos: {
                'id'                : null,
                'nombre'            : '',
                'dm_paquete'        : 0,
                'dm_actualizacion'  : 0,
                'dm_caracteristica' : 0,
                'dd_paquete'        : 0,
                'dd_actualizacion'  : 0,
                'dd_caracteristica' : 0, 
            },
            action: 'save',
        });
    }

	handleChangeInput(event)
	{
		const target 	= event.target;
		const value 	= target.type === 'checkbox' ? target.checked : target.value;
		const name 		= target.name;

		let {descuentos} = this.state;
		descuentos[name] = value;
		this.setState({descuentos: descuentos});
  

	}

	
	
   objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
	handleSubmit(evt)
	{
		evt.preventDefault();
		let {descuentos} = this.state;
		var self = this;
        let check = ['dm_paquete', 'dm_caracteristica', 'dm_actualizacion','dd_paquete', 'dd_caracteristica', 'dd_actualizacion'];
        let save = true;
        for(let i in check) {

            let key = check[i];

            let value = descuentos[key];

            if(value == '' || value == null)
                save = false;

        }
		if(save){
      descuentos=this.objeto_mayusculas(descuentos);
    		this.props[self.state.action](descuentos, () => {

    			swal({
    				title: 'Descuento',
    				text: "Se ha guardado con éxito",
    				type: 'success',
    				// showCancelButton: true,
    				// confirmButtonColor: '#3085d6',
    				// cancelButtonColor: '#d33',
    				confirmButtonText: 'Continuar!'
    			}).then((result) => {
    				if (result.value) {
    					// swal(
    					// 	'Deleted!',
    					// 	'Your file has been deleted.',
    					// 	'success'
    					// 	)
                        self.asNothing();
    					self.props.toggle();
                        
    				}
    			})

    		});
        }else{
            swal("Oops..", "Por favor acompleta todos los campos", "error");
        }
	}

	render()
	{
		let {descuentos} = this.state;

		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label htmlFor="">Cliente</label>
                                <input 
                                 type="text" 
                                 name="nombre" 
                                 value={descuentos.nombre}
                                 onChange={this.handleChangeInput} 
                                 className="form-control" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <br/>
                                <label htmlFor="">Descuento Master</label>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">% Paquete</label>
                                <input 
                                 type="number" 
                                 name="dm_paquete" 
                                 value={descuentos.dm_paquete}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>

                         <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">% Actualizacion</label>
                                <input 
                                 type="number" 
                                 name="dm_actualizacion" 
                                 value={descuentos.dm_actualizacion}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">% Cambio de carac.</label>
                                <input 
                                 type="number" 
                                 name="dm_caracteristica" 
                                 value={descuentos.dm_caracteristica}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="form-group">
                                <br/>
                                <label htmlFor="">Descuento Distribuidor</label>
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">% Paquete</label>
                                <input 
                                 type="number" 
                                 name="dd_paquete" 
                                 value={descuentos.dd_paquete}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>

                         <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">% Actualizacion</label>
                                <input 
                                 type="number" 
                                 name="dd_actualizacion" 
                                 value={descuentos.dd_actualizacion}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-3">
                            <div className="form-group">
                                <label htmlFor="">% Cambio de carac.</label>
                                <input 
                                 type="number" 
                                 name="dd_caracteristica" 
                                 value={descuentos.dd_caracteristica}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    
                    	
                    	<div>
                    		<Button color="success" type="submit" type="submit">
                    			<IconSave />&nbsp;Guardar
                    		</Button>{' '}
                    		<Button color="danger" onClick={this.props.toggle}>
		                    	Cancelar
		                    </Button>
                    	</div>
                    
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
          descuentos: state.descuentos,
        
    }
};

export default connect(mapStateToProps, actions)(DescuentoModal)


// WEBPACK FOOTER //
// ./src/views/descuentoscontpaq/Modal.js